module.exports = __webpack_public_path__ + "img/logout.a7c43e01.webp";